export enum roles {
    PARAdmin = 4,
    Client = 8,
    siteAdmin = 16,
    QAC = 1,
    ResolutionManager = 128    
}


// WEBPACK FOOTER //
// ./src/app/model/roles_Enum.model.ts